export default {
  EXIBIR_COMO_BAIXAR: true,
  EXIBIR_COMO_ENVIAR: true,
  EXIBIR_CADASTRO_ONLINE: true,
  EXIBIR_ACESSAR_ONLINE: true,
  EXIBIR_CONSULTA: {
    LEGISLACAO: true,
    AUTENTICIDADE: true,
    PROCESSO: false,
    TRANSPARENCIA: true,
    FALE_CONOSCO: true,
    SEJA_UM_CREDENCIDADO: true,
    ACERVO_FUNDIARIO: false,
    PORTARIA_HOMOLOGACAO: true,
    PUBLICACAO: true,
    HEADER: true
  },
  EXIBIR_OBSERVACAO_CONSULTA_PROCESSOS: true,
  MAIN: {
    TITULO: 'SICARF - Tecnologia para regularização fundiária das terras do Estado do Pará',
    EXIBIR_IMPORTANTE: true,
    BACK_GROUND: "background-image: url('static/sicarfPrincipal.png')"
  },
  MANUAL_USUARIO: {
    DESCRICAO: 'Utilize estes manuais como um guia de utilização do SiCARF Off-line e Online, eles contêm as informações sobre como realizar os cadastros e importá-los para o Módulo de Análise, para ser possível iniciar o processo de regularização de sua terra.',
    MANUAL_ON: true,
    MANUAL_OFF: true,
    EXIBIR: true
  },
  HOME_PAGE: {
    ENTRE_EM_CONTATO: {
      SOBRE: 'O Instituto de Terras do Pará - ITERPA é um órgão público estadual que tem por objetivos promover a regularização fundiária, entendida como instrumento primeiro para ordenar o espaço e democratizar o acesso à terra.',
      ENDERECO: 'Endereço: Rod. Augusto Montenegro, km 09 s/n - Bairro: Parque Guajará - Icoaraci - CEP: 66.821-000',
      TELEFONE: 'Telefone: (91) 3181-6500',
      SUPORTE: 'Suporte técnico: (91) 3181-6500',
      SITE: 'Site: www.iterpa.pa.gov.br | E-mail: iterpa@iterpa.pa.gov.br',
      HORARIO_FUNCIONAMENTO: 'Horário de funcionamento: Segunda à Sexta-feira, de 08:00 às 14:00 horas.',
      EXIBIR_FORMULARIO: true
    },

    CADASTROS_ONLINE: [
      {
        TOLLTIP: 'Para aqueles que querem confirmar se um título de terras foi expedido ou se a área é pública estadual (jurisdição).',
        SPAN: 'Solicitar <b>informação de autenticidade de títulos</b> e de <b>jurisdição de áreas</b>'
      },
      {
        TOLLTIP: 'Para aqueles que têm títulos de aforamento e desejam pagar o laudêmio.',
        SPAN: 'Solicitar <b>transferência de laudêmio</b>'
      },
      {
        TOLLTIP: 'Para aqueles que têm interesse em realizar o resgate do título de aforamento.',
        SPAN: 'Solicitar <b>resgate de títulos de aforamento</b>'
      },
      {
        TOLLTIP: 'Para aqueles que pretendem fazer o procedimento de permuta.',
        SPAN: 'Solicitar <b>permuta</b>'
      }
    ],

    CADASTROS_OFFLINE: [
      {
        TOLLTIP: 'Regularização fundiária de até 100 ha e exerce agricultura familiar.',
        SPAN: 'Solicitar a <b>Regularização por Doação</b>',
        TEXTO: '(Não onerosa)',
        NEED_BREAK: false
      },
      {
        TOLLTIP: 'Regularização Fundiária de áreas de até 2.500ha para pessoa física ou ' +
          'jurídica que exerce atividade agrária.',
        SPAN: 'Solicitar a <b>Regularização por Compra</b>',
        TEXTO: '(Onerosa)',
        NEED_BREAK: false
      },
      {
        TOLLTIP: 'Para quem precisa da segunda via do título de terras com a confirmação ' +
          'da localização por georreferenciamento, tais como Manejo Florestal, requalificação ' +
          'de matrícula imobiliária, alienação do imóvel, financiamento bancário e outros.',
        TOLLTIP_PART_1: 'Para quem precisa da segunda via do título de terras com a confirmação da localização por georreferenciamento, tais',
        TOLLTIP_PART_2: 'como Manejo Florestal, requalificação de matrícula imobiliária, alienação do imóvel, financiamento bancário e outros.',
        SPAN: 'Solicitar <b>Certidão de Título com Localização Georreferenciada</b>',
        TEXTO: '&nbsp',
        NEED_BREAK: true
      },
      {
        TOLLTIP: 'Regularização fundiária de áreas coletivas formadas por agricultores familiares que estão distribuídos no espaço em lotes.',
        SPAN: 'Solicitar a criação de <b>Assentamento Estadual Sustentável</b>',
        TEXTO: '(AES)',
        NEED_BREAK: false
      },
      {
        TOLLTIP: 'Regularização fundiária de áreas coletivas nas quais não há divisão de lotes entre os agricultores familiares ou comunidades tradicionais.',
        SPAN: 'Solicitar a criação de <b>Assentamento Agroextrativista</b>',
        TEXTO: '(AEX)',
        NEED_BREAK: false
      },
      {
        TOLLTIP: 'Regularização fundiária de comunidades remanescentes de quilombolas.',
        SPAN: 'Solicitar a criação de <b>Território Estadual Quilombola</b>',
        TEXTO: '(TEQ)',
        NEED_BREAK: false
      }
    ],

    TITULO_CADASTRO: 'COMO FAZER O SEU CADASTRO',

    TITULO_CADASTRO_OFF: 'CADASTRO',
    SUBTITULO_CADASTRO_OFF: 'OFF-LINE',

    TITULO_CADASTRO_ON: 'CADASTRO',
    SUBTITULO_CADASTRO_ON: 'ON-LINE',

    TEXTO_CADASTRO: '<strong>Cadastro off-line:</strong> para solicitar os serviços no ITERPA ' +
      'descritos no banner ao lado <strong>Cadastro off-line.</strong> ' +
      'Para realizar os cadastros você deve primeiro instalar no seu computador o sistema.<br/> <br/>' +
      'Atenção! Basta instalar uma vez. <br/><br/>' +
      '<strong>Cadastro on-line:</strong> permite ao usuário solicitar ao ITERPA ' +
      'os serviços específicos identificados no banner <strong>Cadastro on-line.</strong> ' +
      'Para esses serviços, você não precisa baixar nenhum sistema. ' +
      'Basta clicar em "ACESSE" e ter em mãos os documentos necessários no formato digital.',

    O_SICARF_TITULO: 'O SiCARF',

    O_SICARF: 'É o sistema tecnológico do ITERPA voltado para cadastrar, ' +
      'informar e regularizar terras do Estado do Pará de acordo com a legislação. ' +
      'Por meio dele será ampliado o acesso, a eficiência e a trasparência nas solicitação de Regularização Fundiária e ' +
      'demais serviços públicos fundiários usando os benefícios que a ' +
      'tecnologia proporciona a quem precisa ter segurança jurídica. ' +
      'As vantagens do SiCARF são:' +
      '<br>',

    O_SICARF_DESCRICAO: '<b>1.</b> Processo 100% digital, ou seja, sem necessidade do Interessado se deslocar ' +
      'ao ITERPA para cadastrar, juntar documentos, ou consultar o processo; ' +
      '<br>' +
      '<b>2.</b> Módulo off-line para realizar cadastros mesmo sem acesso ' +
      'momentâneo à internet;' +
      '<br>' +
      '<b>3.</b> Notificação e troca de mensagens com o interessado através ' +
      'de ferramenta on-line;' +
      '<br>' +
      '<b>4.</b> Automatização na análise dos processos; (em desenvolvimento);' +
      '<br>' +
      '<b>5.</b> Agilidade no andamento e tramitação dos processos;' +
      '<br>' +
      '<b>6.</b> Desburocratização e maior fluidez do processo de ' +
      'Regularização Fundiária e demais serviços do ITERPA;' +
      '<br>' +
      '<b>7.</b> Transparência de informações junto ao público externo e ' +
      'outros órgãos;',

    O_SICARF_DESCRICAO_IMG: 'static/sicarfReceptor.png',

    EXIBIR_COMENTARIOS: true,

    EXIBIR_GALERIA: true
  },

  VIDEOS_TUTORIAIS: {
    APRESENTACAO: 'https://drive.google.com/file/d/1iJqFKsUDzhQEo44AVkWMwH6ZaV9R9XrW/preview',
    COMO_BAIXAR: 'https://drive.google.com/file/d/1EMOGg32VDRiqAkHhjxjnmMI-Bk-qQwQM/preview',
    COMO_ENVIAR: 'https://drive.google.com/file/d/1VlOQ-oCMAtNwyyUOQuoYQQchZp2HkHbX/preview',
    MANUAL_USUARIO: 'https://drive.google.com/file/d/1GuekZpua0dTy80wf8Xbm3BNU5aCzn8p3/preview',
    MANUAL_USUARIO_OFF: 'https://drive.google.com/file/d/1BeA6qKDiQiPqdSUZyR7hANs7jVuVjksm/preview'
  },

  FOOTER: {
    O_SICARF: 'O SICARF',
    EXIBIR_REDES_SOCIAIS: true,
    ENDERECO: 'Rod. Augusto Montenegro, km 09 s/n - Bairro: Parque Guajará - Icoaraci',
    CEP: 'CEP: 66.821-000',
    LOGO: 'static/governo-pa.svg',
    FACEBOOK: 'https://www.facebook.com/governopara',
    YOUTUBE: 'https://www.youtube.com/channel/UCH5UGma6GF1zbrBRqi8Aifw',
    TWITTER: 'https://twitter.com/governopara',
    INSTAGRAM: 'https://www.instagram.com/governopara/'
  },

  EXIBIR_OBSERVACOES: true,

  EXIBIR_MODELOS_DOCS: false,

  EXIBIR_DUVIDAS_FREQUENTES: true,

  EXIBIR_CREDENCIADOS: true,

  DOCUMENTOS_NECESSARIOS: {
    OBRIGATORIEDADE_SHAPE: true,

    EXIBIR_DOCUMENTO_QUITACAO: false,

    EXIBIR_CERTIDAO_NASCIMENTO: false,

    EXIBIR_DRL: true
  },

  SIMULAR_VTN: {
    DESCRICAO: '',
    EXIBIR: false
  }
}



// WEBPACK FOOTER //
// ./src/constants/pa/dadosEstado/portal/publico.js